import {ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {QueryStringService} from '../../../../services/query-string.service';
import {BasicFilter} from '../../../../models/search/basic-filter';
import {AdvancedFilter} from '../../../../models/search/advanced-filter';
import {KeyValueObject} from '../../../../models/search/filter/key-value-object';
import {BrandService} from '../../../../services/brand.service';
import {Brands} from '../../../../models/Brands';

@Component({
  providers: [
    QueryStringService
  ],
  selector: 'app-list-search',
  templateUrl: './search.component.html',
})
export class SearchComponent implements OnInit {
  @Input() baseSearchFilters: BasicFilter;
  @Input() advancedFilters: AdvancedFilter;
  @Input() newCarsOfferCount: number;
  @Output() pageChangeOnly: EventEmitter<number> = new EventEmitter();
  @Output() filtersUpdate: EventEmitter<void> = new EventEmitter();
  @Output() beforeFiltersUpdate: EventEmitter<boolean> = new EventEmitter();
  @Output() showResults: EventEmitter<void> = new EventEmitter();
  @Input() initOfferCount: any;

  outputTimeouthandler = null;
  toggleAdvancedFilter = true;
  maxLength = null;
  availableValuesMaxHeight: Array<KeyValueObject>;
  brandSlug = '';
  newCarsUrl = '';

  constructor(
    private QSS: QueryStringService,
    private changeDetectorRef: ChangeDetectorRef
  ) {
  }

  ngOnInit() {
    this.maxLength = this.getParamValue('maxLength');
    this.findOffers();
    this.brandSlug = BrandService.getCurrentBrand().slug;
    this.newCarsUrl = BrandService.getCurrentBrand().newCarsUrl;
  }

  public getParamValue(value, forceArray = false) {
    const val = this.QSS.getParam(value, forceArray);

    if (typeof val === 'string' && forceArray) {
      return [val];
    }

    return val;
  }

  public update(eventValues: any): void {
    if (eventValues) {
      this.beforeFiltersUpdate.emit(true);
      if (eventValues.value !== null) {
        if (eventValues.name === 'models') {
          this.clearFilters();
        }
        this.validatePriceValues(eventValues);
        this.validateEnginePowerValues(eventValues);

        if (eventValues.name === 'maxLength') {
          this.QSS.removeParam('maxHeight');
        } else if (eventValues.name === 'models' || eventValues.name === 'version') {
          this.QSS.removeParam('maxLength');
          this.QSS.removeParam('maxHeight');
        }

        this.QSS.setParam(eventValues.name, eventValues.value);
      } else {
        if (eventValues.name === 'maxLength') {
          this.QSS.removeParam('maxHeight');
        } else if (eventValues.name === 'models' || eventValues.name === 'version') {
          this.QSS.removeParam('maxLength');
          this.QSS.removeParam('maxHeight');
        }
        this.QSS.removeParam(eventValues.name);
      }
      clearTimeout(this.outputTimeouthandler);
        this.outputTimeouthandler = setTimeout(() => {
          this.pageChangeEvent(1);
          this.filtersUpdate.emit();
        }, 500);
    }
  }

  private validatePriceValues(eventValues: any) {
    if (eventValues.name === 'price_from' && this.getParamValue('price_to') !== null) {
      if (parseFloat(this.getParamValue('price_to').toString()) < parseFloat(eventValues.value.toString())) {
        this.update({name: 'price_to', value: null});
      }
    }
    if (eventValues.name === 'price_to' && this.getParamValue('price_from') !== null) {
      if (parseFloat(this.getParamValue('price_from').toString()) > parseFloat(eventValues.value.toString())) {
        this.update({name: 'price_from', value: null});
      }
    }
  }

  private validateEnginePowerValues(eventValues: any) {
    if (eventValues.name === 'enginePower_from' && this.getParamValue('enginePower_to') !== null) {
      if (parseFloat(this.getParamValue('enginePower_to').toString()) < parseFloat(eventValues.value.toString())) {
        this.update({name: 'enginePower_to', value: null});
      }
    }
    if (eventValues.name === 'enginePower_to' && this.getParamValue('enginePower_from') !== null) {
      if (parseFloat(this.getParamValue('enginePower_from').toString()) > parseFloat(eventValues.value.toString())) {
        this.update({name: 'enginePower_from', value: null});
      }
    }
  }

  public clearFilters() {
    for (const item of this.getAdvancedSearchFilterNames()) {
      this.update({name: item, value: null});
    }
  }

  public clearFiltersAll() {
    for (const item of this.getBasicSearchFilterNames()) {
      this.update({name: item, value: null});
    }
    this.clearFilters();
  }

  public closeSearchBox() {
    this.showResults.emit();
  }

  public isSelectedAdvancedSearchFilters() {
    for (const item of this.getAdvancedSearchFilterNames()) {
      if (this.getParamValue(item) !== null) {
        return true;
      }
    }
    return false;
  }

  private getAdvancedSearchFilterNames() {
    return ['production_year', 'gearboxType', 'driveType', 'enginePower_from',
      'enginePower_to', 'color', 'interior_type', 'equipment', 'label'];
  }

  private getBasicSearchFilterNames() {
    return ['models', 'version', 'maxLength', 'maxHeight', 'fuelType', 'price_from', 'price_to', 'mileage', 'max_distance'];
  }

  pageChangeEvent(val: number) {
    this.pageChangeOnly.emit(val);
  }

  public findOffers() {
    this.filtersUpdate.emit();
  }

  onChangeToggleAdvancedFilter() {
    this.toggleAdvancedFilter = !this.toggleAdvancedFilter;
  }

  changedLength(eventValues: any) {
    this.maxLength = eventValues;
  }
  changedHeight(eventValues: any) {
    this.availableValuesMaxHeight = eventValues;
  }
}
